import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'odl-rapportino-mod4',
    templateUrl: './print-rapportino-mod4.component.html',
    styleUrls: ['./print-rapportino-mod4.component.scss']
})
export class PrintRapportinoMod4Component implements OnInit {
    @Input() data: { ordine: any, commessa: any };
    constructor() { }

    ngOnInit() {
    }

}
